export const EReaction = {
  default: null,

  raiseHand: '🖐️',
  hooray: '🥳',
  thumbsUp: '👍',
  thumbsDown: '👎',
  heart: '❤️',
  smile: '😁',
  cry: '😭',
} as const

export type ReactionType = keyof typeof EReaction

export interface IReactionData {
  type: ReactionType
  participantId: string
  timestamp: number
  id: string
}
